import { observer } from 'mobx-react-lite';

import styles from './logo.module.css';

export const Logo = observer(() => {
  return (
    <p className={styles.root}>
      <img src="/assets/logo.png" alt="" />
      <span className={styles.title}>Терминалы</span>
    </p>
  );
});
